import { SystemStyleObject } from '@mui/system';
import { NubiTheme } from '@theme';
import { CustomStyles } from '@types';

export const styles: {
  value: SystemStyleObject<NubiTheme>;
  padding0: CustomStyles;
  editButton: CustomStyles;
  container: (responsive: boolean) => CustomStyles;
} = {
  value: { color: ({ palette }) => palette.gray[90] },
  padding0: { padding: 0 },
  editButton: { marginLeft: 2, marginRight: 0.5 },
  container: (responsive: boolean) => ({
    display: 'flex',
    backgroundColor: '#fff',
    gap: '0.5rem',
    borderRadius: '1rem',
    boxShadow: '0px 4px 12px rgba(10, 16, 68, 0.08)',
    padding: '0.75rem',
    flexDirection: 'column',
    flexWrap: responsive ? 'wrap' : 'nowrap',
    alignSelf: 'flex-start',
  }),
};

export const propertyListItemStyle = {
  textContainer: {
    flexDirection: 'column',
    gap: 0,
  },
};
